import { detectClient, devices, } from '@nykaa/utils/device';
import { appLinkTypes, webActionTypes, } from './constants';
const BLANK_NAME = '';
class ClickHandler {
}
ClickHandler.setClient = (client) => {
    ClickHandler.client = client;
};
ClickHandler.handleAndroid = (data) => {
    const { appLinkData, appLinkType, trackingParams = '' } = data;
    if (appLinkData && appLinkType) {
        switch (appLinkType) {
            case appLinkTypes.CATEGORY: {
                // ? appLinkData some time comes as a string and
                // ? the Android doesn't have necessary override
                const transformedAppLinkData = +appLinkData;
                try {
                    window.AndroidFunction.showCategory(transformedAppLinkData, BLANK_NAME, trackingParams);
                }
                catch (error) {
                    window.AndroidFunction.showCategory(transformedAppLinkData, BLANK_NAME);
                }
                break;
            }
            case appLinkTypes.PRODUCT:
                try {
                    window.AndroidFunction.showProduct(appLinkData, BLANK_NAME, trackingParams);
                }
                catch (error) {
                    window.AndroidFunction.showProduct(appLinkData, BLANK_NAME);
                }
                break;
            case appLinkTypes.LANDING:
                // ? TODO: need to validate the url
                window.location.href = appLinkData;
                break;
            default:
                break;
        }
    }
};
ClickHandler.handleIos = (data) => {
    const { appLinkData, appLinkType, trackingParams = '' } = data;
    if (appLinkData && appLinkType) {
        switch (appLinkType) {
            case appLinkTypes.CATEGORY:
                try {
                    window.webkit.messageHandlers.showCategory.postMessage({
                        id: `${appLinkData}`,
                        name: BLANK_NAME,
                        int_cmp: trackingParams,
                    });
                }
                catch (error) {
                    window.location.href = `nykaaioslanding://category?id=${appLinkData}&title=${BLANK_NAME}&int_cmp=${trackingParams}`;
                }
                break;
            case appLinkTypes.PRODUCT:
                try {
                    window.webkit.messageHandlers.openProductPage.postMessage({
                        id: `${appLinkData}`,
                        name: BLANK_NAME,
                        int_cmp: trackingParams,
                    });
                }
                catch (error) {
                    window.location.href = `nykaaioslanding://product?id=${appLinkData}&type=show&title=${BLANK_NAME}&int_cmp=${trackingParams}`;
                }
                break;
            case appLinkTypes.LANDING:
                // ? TODO: need to validate the url
                window.location.href = appLinkData;
                break;
            default:
                break;
        }
    }
};
ClickHandler.handleWeb = (data) => {
    const { webActionType, webActionUrl, isDesktop } = data;
    // ? TODO: should we handle exact cases for webActionType?
    if (webActionUrl) {
        let formattedUrl = webActionUrl;
        if (webActionType === webActionTypes.URL_REDIRECTION) {
            try {
                formattedUrl = decodeURIComponent(webActionUrl);
                // eslint-disable-next-line no-empty
            }
            catch (err) { }
            if (isDesktop) {
                // window.open(formattedUrl);
                // for tablet support
                window.location.href = formattedUrl;
            }
            else {
                window.location.href = formattedUrl;
            }
        }
        else if (webActionType === webActionTypes.PHONE && !isDesktop) {
            window.location.href = `tel:${webActionUrl}`;
        }
    }
};
ClickHandler.executeClickBasedOnClient = (data) => {
    const { device } = ClickHandler.client;
    const { appLinkData, appLinkType, webActionType, webActionUrl, trackingParams, isDesktop, } = data;
    switch (device) {
        case devices.ANDROID:
            ClickHandler.handleAndroid({
                appLinkData,
                appLinkType,
                trackingParams,
            });
            break;
        case devices.IOS:
            ClickHandler.handleIos({ appLinkData, appLinkType, trackingParams });
            break;
        case devices.WEB:
            ClickHandler.handleWeb({ webActionType, webActionUrl, isDesktop });
            break;
        default:
            break;
    }
};
ClickHandler.handleClick = (data) => {
    if (!ClickHandler.client) {
        if (window.navigator) {
            const client = detectClient(window.navigator.userAgent);
            ClickHandler.setClient(client);
        }
    }
    ClickHandler.executeClickBasedOnClient(data);
};
export default ClickHandler;
